import React from "react";
import { Carousel } from "antd";

export const Header = (props) => {
  console.log(props);
  return (
    <div id="header">

      <div className="intro container" >
        <Carousel autoplay draggable={true}>
          {
            props.data && props.data.map((item, index) => {
              return (
                <div index={index} >
                  <img src={item.image} alt="" />
                </div>
              );
            })
          }

        </Carousel>
      </div>
    </div>
  );
};
